import React, { memo } from 'react';
import classNames from 'classnames';

import Button from '../../helpers/Button';
import FieldError from '../../helpers/FieldError';
import useRequiredFieldErrors from '../../../hooks/useRequiredFieldErrors';

import style from './style.module.css';

const SecretCodeFormComponent = ({ isFetching, errorContent, google2FaSecret, onSubmit }) => {
  const { errors, formProps } = useRequiredFieldErrors();

  return (
    <form className={style.host} onSubmit={onSubmit} {...formProps}>
      {google2FaSecret && (
        <>
          <p className={style.hint}>For authentication need to install Google Authenticator App on your smartphone.</p>
          <div className={style.apps}>
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img alt="Google Play" src="/img/google-play-button.png" />
            </a>
            <a
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img alt="App Store" src="/img/app-store-button.png" />
            </a>
          </div>
          <figure className={style.qr}>
            <img alt="QR Code" src={google2FaSecret.get('qrCodeImage')} />
            <figcaption className={style.hint}>Scan QA and enter a code below</figcaption>
          </figure>
        </>
      )}
      <div className={classNames(style.code, { 'has-error': errors.confirmationCode })}>
        <input
          autoComplete="off"
          className="form-control"
          id="confirmationCode"
          inputMode="number"
          maxLength="6"
          name="confirmationCode"
          placeholder="Enter 2FA Code"
          type="tel"
          autoFocus
          required
        />
        <FieldError message={errors.confirmationCode} />
      </div>
      {errorContent}
      <Button className={classNames(style.submit, 'btn-primary btn-block')} loading={isFetching} type="submit">
        Sign in
      </Button>
    </form>
  );
};

export const SecretCodeForm = memo(SecretCodeFormComponent);
